import { render } from "./LoginRecoverEmail.vue?vue&type=template&id=e6854726&scoped=true"
import script from "./LoginRecoverEmail.vue?vue&type=script&lang=js"
export * from "./LoginRecoverEmail.vue?vue&type=script&lang=js"

import "./LoginRecoverEmail.vue?vue&type=style&index=0&id=e6854726&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6854726"]])

export default __exports__